import React from 'react'
import { CircularProgress, makeStyles, styled } from '@material-ui/core'
import { DateObject } from 'react-multi-date-picker'
import CalendarComponent from './Calendar'
import UserAvatar from '../shared/UserAvatar'
import { extractMonth } from '../../utils/extractDate'
import StyledSVG from '../shared/StyledSVG'
import emptyDataPreviewSVG from '../../assets/icons/illustration-calendar-checked.svg'
import moment from 'moment'
import Slider from 'react-slick'

const useStyles = makeStyles(theme => ({
  root: {
    paddingBottom: 16,
    gap: 10,
    display: 'flex',
    width: '100%',
    minWidth: 1100,
    height: 430,
    alignItems: 'flex-start',
    fontFamily: 'Montserrat, Source Sans Pro',
    marginLeft: 11,
    '& .rmdp-day-picker': {
      justifyContent: 'center'
    },
    '& .rmdp-arrow-container': {
      height: 28,
      width: 28,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      borderRadius: 10,
      cursor: 'pointer',
      transition: 'all .2s ease'
    },
    '& .rmdp-arrow-container:hover': {
      backgroundColor: '#F2F5FA',
      transform: 'scale(1.05)',

      '& .rmdp-arrow': {
        borderColor: '#386093'
      }
    },
    '& .rmdp-arrow': {
      border: 'solid #555555',
      borderWidth: '0 2px 2px 0',
      display: 'inline-block',
      height: 10,
      width: 10,
      padding: 0,
      margin: 0,
      transition: 'border-color .2s ease'
    },
    '& .rmdp-header-values': {
      color: '#555555',
      fontSize: 20,
      fontWeight: 600
    },
    '& .rmdp-week-day': {
      color: '#9B9B9B'
    },
    '& .rmdp-shadow': {
      boxShadow: 'none'
    },
    '& .rmdp-calendar': {
      width: '100%'
    },
    '& .rmdp-header': {
      width: '100%'
    },
    '& .rmdp-week': {
      width: 430,
      [theme.breakpoints.down('1882')]: {
        width: 290
      },
      [theme.breakpoints.down('1600')]: {
        width: 300
      },
      [theme.breakpoints.down('1450')]: {
        width: 250
      },
      [theme.breakpoints.down('1600')]: {
        width: 300
      },
      [theme.breakpoints.down('1600')]: {
        width: 300
      }
    },
    '& .rmdp-day.rmdp-selected span:not(.highlight)': {
      boxShadow: 'none',
      backgroundColor: 'unset'
    },
    '& .rmdp-day:not(.rmdp-disabled,.rmdp-day-hidden) span:hover': {
      color: 'unset'
    },
    '& .rmdp-day.rmdp-today span': {
      color: '#386093'
    },
    '& .rmdp-day.rmdp-today': {
      border: 'solid #386093',
      borderRadius: 56
    },
    '&::-webkit-scrollbar': {
      width: 5,
      height: 5
    },
    '&::-webkit-scrollbar-track': {
      '-webkit-border-radius': '10px',
      'border-radius': '10px'
    },
    '&::-webkit-scrollbar-thumb': {
      '-webkit-border-radius': '10px',
      'border-radius': '10px',
      background: 'rgba(173, 184, 204, 1)'
    },
    [theme.breakpoints.down('1600')]: {
      marginLeft: 7
    }
  },
  title: {
    fontWeight: 600,
    fontSize: 27,
    color: '#386093',
    margin: 0,
    [theme.breakpoints.down('600')]: {
      margin: '20px 0px',
      textAlign: 'center'
    }
  },
  calendar_wrapper: {
    padding: 16,
    width: '29%',
    height: 400,
    backgroundColor: '#FFFFFF',
    borderRadius: 16,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center'
  },
  event_card_componentes_wrapper: {
    padding: '15px 26px 15px 26px',
    margin: 0,
    '& .title': {
      fontSize: 14
    }
  },
  event_card_componentes_title_wrapper: {
    width: '100%',
    margin: '0px',
    borderBottom: '2px solid #E7EAF0',
    '& .title': {
      fontSize: 18,
      padding: '25px 30px 20px 30px',
      margin: 0,
      display: '-webkit-box',
      WebkitLineClamp: 1,
      WebkitBoxOrient: 'vertical',
      overflow: 'hidden'
    }
  },
  // wrapper para dar o efeito do scroll interno
  event_card_wrapper: {
    width: '100%',
    minHeight: 400,
    height: 'fit-content',
    maxHeight: 300,
    overflowY: 'auto',
    backgroundColor: '#FFFFFF',
    borderRadius: 24
  },
  event_card: {
    maxHeight: 400,
    overflowY: 'auto',
    '& .title': {
      margin: 0,
      fontWeight: 600,
      fontSize: 20
    },
    '&::-webkit-scrollbar': {
      width: '5px'
    },
    '&::-webkit-scrollbar-track': {
      '-webkit-border-radius': '10px',
      'border-radius': '10px'
    },
    '&::-webkit-scrollbar-thumb': {
      '-webkit-border-radius': '10px',
      'border-radius': '10px',
      background: 'rgba(173, 184, 204, 1)'
    }
  },
  avatar: {
    '& span.userName': {
      fontSize: 16,
      fontWeight: 600
    }
  },
  event_overview: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginTop: 8
  },
  event_overview_item: {
    display: 'flex',
    flexDirection: 'column',
    gap: 8,
    '& .event': {
      backgroundColor: '#D9E8FACC',
      color: '#555555'
    },
    '& .start': {
      backgroundColor: '#EF7C8F',
      color: '#FFFFFF'
    },
    '& .end': {
      backgroundColor: '#F4A87C',
      color: '#FFFFFF'
    },
    '& .confirmation': {
      backgroundColor: '#E9FAD9',
      color: '#555555'
    },
    '& span.label': {
      fontWeight: 500,
      fontFamily: 'Montserrat',
      fontSize: '14px',
      fontStyle: 'normal',
      lineHeight: '150%',
      color: '#555555'
    }
  },
  event_overview_item_value: {
    padding: 8,
    borderRadius: 32,
    height: 30,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    '& .value': {
      fontSize: 12,
      fontWeight: 500
    }
  },
  event_description: {
    padding: '20px',
    '& video': {
      width: '100%',
      height: 'auto'
    },
    '& img': {
      width: '100%',
      height: 'auto',
      margin: '10px 0px'
    },
    '& iframe': {
      width: '100% !important',
      aspectRatio: '16 / 9',
      height: 'auto !important',
      display: 'block',
      margin: '0 auto'
    }
  },
  events_cards: {
    width: '70%',
    height: 420,
    overflow: 'hidden',
    '& .slick-slide': {
      padding: '0px 8px'
    },
    '& .slick-list': {
      width: '100%',
      margin: 0
    },
    '& .slick-dots': {
      bottom: '-21px'
    }
  },
  empty_data_wrapper: {
    height: 400,
    width: '98.5%',
    backgroundColor: '#FFFFFF',
    borderRadius: 16,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    rowGap: 16,
    marginLeft: 10,
    '& .description': {
      textAlign: 'center',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      '& h1': {
        margin: 0,
        color: '#386093',
        fontSize: 24
      },
      '& p': {
        margin: 0,
        fontWeight: 400,
        fontSize: 16,
        maxWidth: 460
      }
    },
    [theme.breakpoints.down('1600')]: {
      width: '98%'
    }
  },
  event_content: {
    marginTop: 16,
    overflow: 'auto',
    cursor: 'pointer',
    borderRadius: 8,
    backgroundColor: '#fffafa',
    height: 160,
    '& p': {
      margin: 0,
      fontWeight: 500,
      fontFamily: 'Montserrat',
      fontSize: '14px',
      fontStyle: 'normal',
      lineHeight: '150%',
      color: '#555555'
    },
    '& h2,h1,h3,h4,h5': {
      margin: '0px 0px 15px 0px'
    },
    '&::-webkit-scrollbar': {
      width: '5px'
    },
    '&::-webkit-scrollbar-track': {
      '-webkit-border-radius': '10px',
      'border-radius': '10px'
    },
    '&::-webkit-scrollbar-thumb': {
      '-webkit-border-radius': '10px',
      'border-radius': '10px',
      background: 'rgba(173, 184, 204, 1)'
    }
  }
}))

const EventCardCalendar = styled('div')(({ bgColor, maxHeight }) => ({
  borderRadius: 16,
  maxHeight: maxHeight,
  backgroundColor: bgColor,
  cursor: 'grab',
  width: 500,
  overflow: 'hidden'
}))

const EventCalendar = ({ getEvents, events, history, isAdmin }) => {
  const classes = useStyles()
  const [viewDate, setViewDate] = React.useState(() => new DateObject())
  React.useEffect(() => {
    fetchByMonth(viewDate)
  }, [])

  const highlightedDays = React.useMemo(
    () => {
      const items = events?.items || []
      return new Set(
        items.map(item => {
          const d = new Date(item?.event_date)
          d.setHours(0, 0, 0, 0)
          return d.getTime()
        })
      )
    },
    [events?.items]
  )

  const fetchByMonth = dateObj => {
    const { beginningOfMonth, endOfMonth } = extractMonth(dateObj)
    getEvents({
      params: {
        'q[event_date_gteq]': beginningOfMonth,
        'q[event_date_lteq]': endOfMonth,
        'q[event_type_eq]': 'events'
      },
      isAdmin
    })
  }

  const handleViewChange = next => {
    setViewDate(next)
    fetchByMonth(next)
  }

  const handleClickItem = eventId => {
    history.push(`/announcements?id=${eventId}&name=view`)
  }

  return (
    <div className={classes.root}>
      <div className={classes.calendar_wrapper}>
        <h1 className={classes.title}>Calendário de eventos</h1>
        <CalendarComponent
          viewDate={viewDate}
          hideYear
          onDateChange={handleViewChange}
          mapDays={({ date }) => {
            const setedTimeStamp = new Date(
              date.year,
              date.month.index,
              date.day
            ).setHours(0, 0, 0, 0)
            const isHighlighted = highlightedDays.has(setedTimeStamp)
            return {
              style: {
                backgroundColor: isHighlighted ? '#EF7C8F' : 'unset',
                color: isHighlighted ? '#FFFFFF' : 'unset',
                cursor: 'pointer'
              }
            }
          }}
        />
      </div>
      <div className={classes.events_cards}>
        {events?.isFetching ? (
          <div className={classes.empty_data_wrapper}>
            <CircularProgress />
          </div>
        ) : events?.items.length > 0 ? (
          <Slider dots infinite={false} slidesToShow={2} slidesToScroll={1}>
            {events?.items.map((item, idx) => {
              return (
                <EventCardCalendar
                  bgColor={'#fff'}
                  maxHeight={200}
                  key={idx}
                  className={classes.event_card_wrapper}
                >
                  <div>
                    <div
                      className={classes.event_card_componentes_title_wrapper}
                    >
                      <h1 className='title'>{item.title}</h1>
                    </div>
                    <div className={classes.event_card_componentes_wrapper}>
                      <UserAvatar
                        className={classes.avatar}
                        avatarStyle={{ width: 40, height: 40 }}
                        avatarUrl={item?.user?.avatar_url}
                        userName={item?.user?.name}
                      />
                      <div className={classes.event_overview}>
                        <div className={classes.event_overview_item}>
                          <span className='label'>Evento:</span>
                          <div
                            className={`${
                              classes.event_overview_item_value
                            } event`}
                          >
                            <span className='value'>
                              {moment(item.event_date).format('DD/MM/YYYY')}
                            </span>
                          </div>
                        </div>
                        <div className={classes.event_overview_item}>
                          <span className='label'>Início:</span>
                          <div
                            className={`${
                              classes.event_overview_item_value
                            } start`}
                          >
                            <span className='value'>
                              {moment(item.start_time).format('HH:mm')}
                            </span>
                          </div>
                        </div>
                        <div className={classes.event_overview_item}>
                          <span className='label'>Término:</span>
                          <div
                            className={`${
                              classes.event_overview_item_value
                            } end`}
                          >
                            <span className='value'>
                              {moment(item.end_time).format('HH:mm')}
                            </span>
                          </div>
                        </div>
                        <div className={classes.event_overview_item}>
                          <span className='label'>Confirmações:</span>
                          <div
                            className={`${
                              classes.event_overview_item_value
                            } confirmation`}
                          >
                            <span className='value'>
                              {item.participants.length}
                            </span>
                          </div>
                        </div>
                      </div>
                      <div
                        onClick={() => handleClickItem(item.id)}
                        className={classes.event_content}
                      >
                        <p
                          dangerouslySetInnerHTML={{
                            __html: item.description
                          }}
                          className={classes.event_description}
                        />
                      </div>
                    </div>
                  </div>
                </EventCardCalendar>
              )
            })}
          </Slider>
        ) : (
          <div className={classes.empty_data_wrapper}>
            <StyledSVG src={emptyDataPreviewSVG} width={160} height={160} />
            <div className='description'>
              <h1>Agenda tranquila por aqui</h1>
              <p>Os eventos da escola serão exibidos neste calendário.</p>
            </div>
          </div>
        )}
      </div>
    </div>
  )
}

export default EventCalendar
